/*
  PULSE HOMEPAGE CLICK + REACH TRACKING (GA4). Andre, 2026-09-13: "is it possible for us to
  understand what people are clicking on when they land on the homepage? ... are they clicking on
  the hero buttons or product, or are they going further down and clicking on different things?"

  Loaded from layout/theme.liquid on the INDEX template only. Sends two GA4 events through the
  storefront's own gtag (the Google & YouTube app's tag), exactly like pulse-size-track.js:

    home_section_view  once per section per page view, when it is genuinely on screen
                       (half of it visible, or half the viewport filled by it for a tall one)
    home_click         every tap on a link, button or FAQ question anywhere on the page

  Parameters, all registered as GA4 custom dimensions (scripts/ga4/custom_dimensions.py):
    home_section      readable section name, from the section key in templates/index.json
    section_position  1 = hero, counted down the page; header and footer send "0"
    click_kind        what sort of thing was tapped (product card, quick add size, hero button ...)
    click_label       its text: button label, card title, link text (100 chars max, GA4's limit)
    click_target      the path it leads to, query string stripped ("" for an in-page control)
    item_position     for cards and repeated controls, which one (1-based) within the section
    market            Shopify.country

  NO MARKUP CHANGES. Sections are identified by Shopify's own wrapper id
  (shopify-section-<template>__<key>), so a section added in the theme editor is tracked with
  its key as the name until it is given a label in SECTION_NAMES.

  DRAGS ARE NOT CLICKS. pulse-drag-rail.js swallows the click that ends a drag, in the capture
  phase on the rail. This listener is capture phase on the document, so it runs FIRST and would
  count every drag release as a card tap. A press that travelled 5 px sideways (the rail's own
  THRESHOLD) inside an .is-draggable rail is skipped for the same reason the rail skips it.

  Debug: add ?pds_track_debug=1 to the URL to log every event to the console.
*/
(function () {
  if (window.PulseHomeTrack) return;
  var GA_ID = 'G-13Z0TZ2YTY';
  var DEBUG = /[?&]pds_track_debug=1/.test(location.search);

  var SECTION_NAMES = {
    pulse_announcement: 'Announcement bar',
    pulse_nav: 'Header menu',
    hero: 'Hero',
    shop_rail: 'Shop rail',
    meet_range: 'Meet the range',
    style_cards: 'Style cards',
    band: 'Editorial band',
    routes: 'Clearance / Wide fit / New tiles',
    tech_pin: 'Technology',
    folders: 'Danced in, everywhere',
    film: 'Film',
    best_sellers: 'Where dancers start',
    faq: 'FAQ',
    pulse_footer: 'Footer'
  };

  /* First match wins, so the specific controls sit above the generic link and button rules. */
  var KINDS = [
    ['.psh__cta', 'hero button'],
    ['.cx2-size', 'quick add size'],
    ['.cx2-quick', 'quick add'],
    ['.cx2-save', 'save'],
    ['.cx2-col', 'colour swatch'],
    ['.cx2-scale__btn', 'women / men toggle'],
    ['.psr__navbtn, [data-rail-prev], [data-rail-next], [data-fd-reel-prev], [data-fd-reel-next]', 'carousel arrow'],
    ['[data-fd-reel-to]', 'clip dot'],
    ['[data-fd-prev], [data-fd-next]', 'review arrow'],
    ['.fd__spine', 'dance style tab'],
    ['.fd__cta', 'dance style shop link'],
    ['.cx-wall__link', 'product card'],
    ['summary', 'faq question']
  ];
  var CLICKABLE = 'a[href], button, summary, [role="button"]';

  function clip(s, n) {
    s = String(s || '').replace(/\s+/g, ' ').trim();
    return s.length > (n || 100) ? s.slice(0, n || 100) : s;
  }

  function send(name, params) {
    params.market = (window.Shopify && Shopify.country) || '';
    if (DEBUG) console.log('[pulse-home-track]', name, params);
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', name, Object.assign({ send_to: GA_ID }, params));
  }

  function sectionOf(el) {
    var wrap = el.closest('.shopify-section');
    if (!wrap) return null;
    var key = (wrap.id || '').split('__').pop() || wrap.id;
    return { el: wrap, key: key, name: SECTION_NAMES[key] || key };
  }

  function positionOf(wrap) {
    if (!wrap.closest('main')) return '0';
    var all = document.querySelectorAll('main .shopify-section');
    return String(Array.prototype.indexOf.call(all, wrap) + 1);
  }

  function kindOf(el) {
    for (var i = 0; i < KINDS.length; i++) if (el.matches(KINDS[i][0])) return KINDS[i][1];
    if (el.matches('a[href]')) {
      var p = el.pathname || '';
      if (p.indexOf('/products/') > -1) return 'product link';
      if (p.indexOf('/collections/') > -1) return 'collection link';
      if (p.indexOf('/pages/') > -1) return 'page link';
      return 'link';
    }
    return 'button';
  }

  /* textContent, not innerText: innerText applies text-transform, so every uppercase-styled
     button would arrive in GA4 as "SHOP WOMEN" and split from the same label written normally. */
  function textOf(el) {
    return el ? clip(el.textContent) : '';
  }

  /* The card title carries BOTH "Women's " and "Men's " spans and CSS shows one. Drop both, so a
     product groups as "Nova Court" whichever scale the rail is on (the toggle is its own click). */
  function cardTitle(title) {
    var parts = [];
    Array.prototype.forEach.call(title.childNodes, function (n) {
      if (n.nodeType === 1 && n.matches('.cx2-w, .cx2-m')) return;
      parts.push(n.textContent);
    });
    return clip(parts.join(''));
  }

  function labelOf(el) {
    var card = el.closest('.cx-wall__cell');
    var title = card && card.querySelector('.cx-meta__title');
    var img = el.querySelector('img');
    var own = el.getAttribute('aria-label') || textOf(el) || el.getAttribute('title') || (img && img.alt) || '';
    if (!title) return clip(own);
    /* Card controls: "Flow 2 Rouge" for the card itself, "Flow 2 Rouge: Women's US 7" for a size. */
    var name = cardTitle(title);
    return el.matches('.cx-wall__link') || !own ? name : clip(name + ': ' + clip(own, 60));
  }

  function itemPositionOf(el, section) {
    var card = el.closest('.cx-wall__cell');
    if (card && card.parentElement) {
      return String(Array.prototype.indexOf.call(card.parentElement.children, card) + 1);
    }
    var cls = el.classList[0];
    if (!cls) return '';
    var same = section.el.querySelectorAll(el.tagName.toLowerCase() + '.' + CSS.escape(cls));
    return same.length > 1 ? String(Array.prototype.indexOf.call(same, el) + 1) : '';
  }

  /* ---- clicks ---- */
  var down = null;
  document.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY }; }, { capture: true, passive: true });

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest(CLICKABLE);
    if (!el) return;
    if (down && e.detail > 0 && Math.abs(e.clientX - down.x) >= 5 && el.closest('.is-draggable')) return;
    var section = sectionOf(el);
    if (!section) return;
    send('home_click', {
      home_section: section.name,
      section_position: positionOf(section.el),
      click_kind: kindOf(el),
      click_label: labelOf(el),
      click_target: el.matches('a[href]') && el.host === location.host ? clip(el.pathname) :
        el.matches('a[href]') ? clip(el.href) : '',
      item_position: itemPositionOf(el, section)
    });
  }, true);

  /* ---- reach: which sections were actually on screen ---- */
  if ('IntersectionObserver' in window) {
    var seen = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        /* A zero-height section (the film before its video sizes itself) can report as
           intersecting with a ratio of 1 while sitting on the fold; it has not been seen. */
        if (!en.isIntersecting || en.boundingClientRect.height === 0) return;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var onScreen = en.intersectionRatio >= 0.5 || en.intersectionRect.height >= vh * 0.5;
        if (!onScreen) return;
        var s = sectionOf(en.target);
        if (!s || seen[s.el.id]) return;
        seen[s.el.id] = true;
        io.unobserve(en.target);
        send('home_section_view', { home_section: s.name, section_position: positionOf(s.el) });
      });
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    var start = function () {
      document.querySelectorAll('main .shopify-section, .shopify-section-group-footer-group').forEach(function (s) {
        io.observe(s);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }

  window.PulseHomeTrack = { send: send, sectionOf: sectionOf };
})();
